import React, { createContext, useState } from "react";
import { PersonsService } from "../services/personsService";
import { useDispatch, useSelector } from "react-redux";
import { authActions } from "../app/store";

export const SuperOrgContext = createContext();
const SuperOrgContextProvider = (props) => {
  const { user: authUser } = useSelector((x) => x.auth);
  const [super_organisation_id, setSuperOrganisationId] = useState(
    authUser?.organisation?.id
  );
  const dispatch = useDispatch();

  const modifySuperOrg = (org_id) => {
    return new Promise((resolve, reject) => {
      PersonsService.setOrganisation(org_id).then((response) => {
        if (response.success) {
          setSuperOrganisationId(org_id);
          // resolve(`changed org id to ${org_id}`);
          dispatch(authActions.setUserOrg(response.data));
          // setUserInfoLoading(true);
          // PersonsService.getPersonById(authUser?.id)
          //   .then((response) => {
          //     // setUserInfoLoading(false);
          //     dispatch(authActions.setUsetInfo(response));
          //   })
          //   .catch((error) => {
          //     console.log(error);
          //     // setUserInfoLoading(false);
          //     resolve(`changed org id to ${org_id}`);
          //   });
        } else {
          reject(`error changing org id to ${org_id}`);
        }
      });
    });
  };

  // useEffect(() => {
  //   if (
  //     authUser?.organisation_id &&
  //     authUser?.organisation_id !== super_organisation_id &&
  //     ["Super Admin"].includes(authUser.role?.name)
  //   )
  //     modifySuperOrg(authUser?.organisation_id);
  // }, [authUser?.organisation_id]);

  return (
    <SuperOrgContext.Provider value={{ super_organisation_id, modifySuperOrg }}>
      {props.children}
    </SuperOrgContext.Provider>
  );
};

export default SuperOrgContextProvider;

